// import demo from './modules/demo'
// import userManagement from './modules/userManagement'
import layoutHeaderAside from '@/layout/header-aside'

const meta = { requiresAuth: true }

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    redirect: { name: 'index' },
    component: layoutHeaderAside,
    children: [
      // 首页 必须 name:index
      {
        path: 'index',
        name: 'index',
        meta,
        component: () => import('@/pages/index')
      },
      {
        path: 'ai-rights',
        redirect: '/ai-rights/organizations'
      },
      {
        path: 'demo/miniProgramQrCode',
        name: 'miniProgramQrCode',
        meta: { meta, title: '小程序码生成' },
        component: () => import('@/pages/demo/miniProgramQrCode/index.vue')
      },
      {
        path: 'demo/commodity/addition',
        name: 'commodityAdd',
        meta: { meta, title: '商品添加' },
        component: () => import('@/pages/demo/commodity/addition')
      },
      {
        path: 'demo/luckDraw/addAndModify',
        name: 'addAndModifyADdd',
        meta: { meta, title: '抽奖添加' },
        component: () => import('@/pages/demo/luckDraw/addAndModify')
      },
      {
        path: 'demo/medal/addMedal',
        name: 'medalAddManger',
        meta: { meta, title: '勋章添加' },
        component: () => import('@/pages/demo/medal/addMedal')
      },
      {
        path: 'demo/competition/addContest',
        name: 'addContestManger',
        meta: { meta, title: '大赛添加' },
        component: () => import('@/pages/demo/competition/addContest')
      },
      {
        path: 'demo/command/addCom',
        name: 'addComAdd',
        meta: { meta, title: '口令添加' },
        component: () => import('@/pages/demo/command/addCom')
      },
      {
        path: 'demo/luckDraw/lotteryRecord',
        name: 'lotteryRecordADdd',
        meta: { meta, title: '抽奖记录' },
        component: () => import('@/pages/demo/luckDraw/lotteryRecord')
      },
      {
        path: 'demo/command/rceivings',
        name: 'rceivingsADdd',
        meta: { meta, title: '领取记录' },
        component: () => import('@/pages/demo/command/rceivings')
      },
      {
        path: 'demo/user/leadDrilsl',
        name: 'leadDrilslADdd',
        meta: { meta, title: '领钻记录' },
        component: () => import('@/pages/demo/user/leadDrilsl')
      },
      {
        path: 'demo/user/userDetails',
        name: 'userDetails',
        meta: { meta, title: '用户详情' },
        component: () => import('@/pages/demo/user/userDetails')
      },
      {
        path: 'demo/discount/addDiscount',
        name: 'discountAdd',
        meta: { meta, title: '优惠券添加' },
        component: () => import('@/pages/demo/discount/addDiscount')
      },
      {
        path: 'demo/configuration/webTemplateEdit',
        name: 'webTemplateEdit',
        meta: { meta, title: '新建配置' },
        component: () => import('@/pages/demo/configuration/webTemplateEdit')
      },
      {
        path: 'demo/order/orderDetail',
        name: 'orderDetail',
        meta: { meta, title: '主订单详情' },
        component: () => import('@/pages/demo/order/orderDetail')
      },
      {
        path: 'demo/Imprint/ImprintDetail',
        name: 'ImprintDetail',
        meta: { meta, title: '新增印记产品' },
        component: () => import('@/pages/demo/Imprint/ImprintDetail')
      },
      {
        path: 'demo/inspiration/addInspiration',
        name: 'addInspiration',
        meta: { meta, title: '新增话题明细' },
        component: () => import('@/pages/demo/inspiration/addInspiration')
      },
      {
        path: 'demo/newPeople/addNewGift',
        name: 'addNewGift',
        meta: { meta, title: '新增首页弹窗' },
        component: () => import('@/pages/demo/newPeople/addNewGift')
      },
      {
        path: 'demo/close/addCloseCertifi',
        name: 'addCloseCertifi',
        meta: { meta, title: '新增亲密之证' },
        component: () => import('@/pages/demo/close/addCloseCertifi')
      },
      {
        path: 'demo/punchTheClock/addToCard',
        name: 'addToCard',
        meta: { meta, title: '新增打卡任务' },
        component: () => import('@/pages/demo/punchTheClock/addToCard')
      },
      {
        path: 'demo/punchTheClockTpl/addToCard',
        name: 'addThemeTpl',
        meta: { meta, title: '新增任务模版' },
        component: () => import('@/pages/demo/punchTheClockTpl/addToCard')
      },
      {
        path: 'demo/loveCounselor/addLoveCoun',
        name: 'addLoveCoun',
        meta: { meta, title: '新增表单' },
        component: () => import('@/pages/demo/loveCounselor/addLoveCoun')
      },
      {
        path: 'demo/attributes/addAttributes',
        name: 'addAttributes',
        meta: { meta, title: '新增属性' },
        component: () => import('@/pages/demo/attributes/addAttributes')
      },
      {
        path: 'demo/certificateList/baseList',
        name: 'certbaseList',
        meta: { meta, title: '基础属性' },
        component: () => import('@/pages/demo/certificateList/baseList')
      },
      {
        path: 'demo/CommissionRelate/addToCR',
        name: 'addToCR',
        meta: { meta, title: '新增委托' },
        component: () => import('@/pages/demo/CommissionRelate/addToCR')
      },
      {
        path: 'demo/GrowthCoin/addGrowthCoin',
        name: 'addGrowthCoin',
        meta: { meta, title: '新增成长币' },
        component: () => import('@/pages/demo/GrowthCoin/addGrowthCoin')
      },
      {
        path: 'demo/CommissionRelate/delegationDetails',
        name: 'delegationDetails',
        meta: { meta, title: '卡片列表' },
        component: () =>
          import('@/pages/demo/CommissionRelate/delegationDetails')
      },
      {
        path: 'demo/growMent/growAdd',
        name: 'growAddM',
        meta: { meta, title: '编辑成长协议' },
        component: () => import('@/pages/demo/growMent/growAdd')
      },
      {
        path: 'demo/systemTasks/createTask',
        name: 'createTask',
        meta: { meta, title: '编辑系统任务' },
        component: () => import('@/pages/demo/systemTasks/createTask')
      },
      {
        path: 'demo/map/addMap',
        name: 'maps',
        meta: { meta, title: '编辑地图' },
        component: () => import('@/pages/demo/map/addMap')
      },
      {
        path: 'demo/poster/posterEditor',
        name: 'posterEditor',
        meta: { meta, title: '编辑海报' },
        component: () => import('@/pages/demo/poster/posterEditor')
      },
      {
        path: 'demo/fission/editFission',
        name: 'editFission',
        meta: { meta, title: '编辑裂变' },
        component: () => import('@/pages/demo/fission/editFission')
      },
      {
        path: 'demo/helper/keyword/edit',
        name: 'editHelperKeyword',
        meta: { meta, title: '编辑触发关键字' },
        component: () => import('@/pages/demo/helper/keyword/edit')
      },
      {
        path: 'demo/helper/content/edit',
        name: 'editHelperContent',
        meta: { meta, title: '编辑回复内容' },
        component: () => import('@/pages/demo/helper/content/edit')
      },
      {
        path: 'demo/helper/questionnaire/edit',
        name: 'editQuestionnaireContent',
        meta: { meta, title: '编辑调查问卷' },
        component: () => import('@/pages/demo/helper/questionnaire/edit')
      },
      {
        path: 'merchant/service/productCate/edit',
        name: 'editServiceProductCate',
        meta: { meta, title: '编辑产品分类' },
        component: () => import('@/pages/merchant/service/productCate/edit')
      }, {
        path: 'merchant/service/product/edit',
        name: 'editServiceProduct',
        meta: { meta, title: '编辑产品' },
        component: () => import('@/pages/merchant/service/product/edit')      },
      {
        path: 'demo/user/tag/edit',
        name: 'editUserTag',
        meta: { meta, title: '编辑标签' },
        component: () => import('@/pages/demo/user/tag/edit')
      },
      {
        path: 'merchant/service/project/add',
        name: 'addProject',
        meta: { meta, title: '项目信息' },
        component: () => import('@/pages/merchant/service/project/add')
      },
      {
        path: 'merchant/service/project/layout-template',
        name: 'canvasLayoutTemplate',
        meta: { meta, title: '排版模板管理' },
        component: () => import('@/pages/merchant/service/project/layoutTemplate.vue')
      },
      {
        path: 'demo/file/category/edit',
        name: 'fileCategoryEdit',
        meta: { meta, title: '文件分类' },
        component: () => import('@/pages/demo/file/category/edit')
      },

      {
        path: 'demo/file/tag/edit',
        name: 'fileTagEdit',
        meta: { meta, title: '文件标签' },
        component: () => import('@/pages/demo/file/tag/edit')
      },
      {
        path: 'demo/file/resource/edit',
        name: 'fileResourceEdit',
        meta: { meta, title: '文件资源' },
        component: () => import('@/pages/demo/file/resource/edit')
      },
      {
        path: 'demo/veriOrder/edit',
        name: 'editVeriOrder',
        meta: { meta, title: '销售单' },
        component: () => import('@/pages/demo/veriOrder/edit')
      },
      {
        path: 'demo/veriOrder/record',
        name: 'recordVeriOrder',
        meta: { meta, title: '销售记录' },
        component: () => import('@/pages/demo/veriOrder/record')
      },
      {
        path: 'merchant/service/product/productSpecValues',
        name: 'productSpecValues',
        meta: { meta, title: '规格值管理' },
        component: () => import('@/pages/merchant/service/product/productSpecValues.vue')
      },
      {
        path: 'merchant/agent/industry/edit',
        name: 'editAgentIndustry',
        meta: { meta, title: '编辑行业' },
        component: () => import('@/pages/merchant/agent/industry/edit')
      },
      {
        path: 'merchant/agent/bot/leeBotChat',
        name: 'leeBotChat',
        meta: { meta, title: '栗宝模拟聊天' },
        component: () => import('@/pages/merchant/agent/bot/leeBotChat.vue')
      },
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: {
          beforeRouteEnter (to, from, next) {
            next((vm) => vm.$router.replace(from.fullPath))
          },
          render: (h) => h()
        }
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: {
          beforeRouteEnter (to, from, next) {
            next((vm) => vm.$router.replace(JSON.parse(from.params.route)))
          },
          render: (h) => h()
        }
      }
    ]
  }
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login')
  },
  {
    path: '/merchant/service/project/info',
    name: 'serviceProjectInfo',
    meta: { meta, title: '项目信息' },
    component: () => import('@/pages/merchant/service/project/info')
  },
  {
    path: '/merchant/service/project/aigc',
    name: 'aigc',
    meta: { meta, title: 'AIGC' },
    component: () => import('@/pages/merchant/service/project/aigc.vue')
  },
  {
    path: '/merchant/service/project/aigcTheme',
    name: 'aigcTheme',
    meta: { meta, title: '主题编辑' },
    component: () => import('@/pages/merchant/service/project/aigcTheme.vue')
  },
  {
    path: '/merchant/service/project/aigcTaskInfo',
    name: 'aigcTaskInfo',
    meta: { meta, title: '任务详情' },
    component: () => import('@/pages/merchant/service/project/aigcTaskInfo.vue')
  },
  {
    path: '/merchant/service/project/sources',
    name: 'serviceProjectSources',
    meta: { meta, title: '交付管理' },
    component: () => import('@/pages/merchant/service/project/sources')
  },
  {
    path: '/merchant/agent/industry/train',
    name: 'trainAgentIndustry',
    meta: { meta, title: '行业数据训练' },
    component: () => import('@/pages/merchant/agent/industry/train')
  }
]

/**
 * 错误页面
 */
const errorPage = [
  // 404
  {
    path: '*',
    name: '404',
    component: () => import('@/pages/error-page-404')
  }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [...frameIn, ...frameOut, ...errorPage]
